import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=50c56770&scoped=true&"
import script from "./MaterialDetail.vue?vue&type=script&lang=ts&"
export * from "./MaterialDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialDetail.vue?vue&type=style&index=0&id=50c56770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c56770",
  null
  
)

export default component.exports